import { Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Skeleton, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Create, FormDataConsumer, required, SimpleForm, TextInput,  useCreate,  useNotify,  useRedirect,  useTranslate } from 'react-admin'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { supplierServices } from 'src/services/reservation/supplier/supplier.service'
import { ItemsTable } from '../logic/ItemsTable'
import { CheckItemsModal } from './logic/CheckItemsModal'
import { LoadingButton } from '@mui/lab'
import { supplierBillingServices } from 'src/services/purchases/supplier_billing/SupplierBilling.service'
import { CardCommon } from 'src/components/uiElements'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { billingServices } from 'src/services/reservation/billing/billing.service'
import dayjs from 'dayjs'
import { currencyServices } from 'src/services/reservation/currency/currency.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { blue } from 'src/assets/colors'
import { Add, Delete, InsertDriveFile } from '@mui/icons-material'
import { itemSupplierServices } from 'src/services/purchases/item_supplier/ItemSupplier.service'
import { useErrorHandler } from 'src/hooks/useErrorHandler'

export const SupplierBillingCreate = (props) => {
    const notify = useNotify()
    const redirect = useRedirect()
    const translate = useTranslate()
    const showError = useErrorHandler()
    const [create] = useCreate()
    const [supplierLoading, setSupplierLoading] = useState(false)
    const [supplierOptions, setSupplierOptions] = useState([])
    const [loadingBasesList, setLoadingBasesList] = useState(false)
    const [basesList, setBasesList] = useState([])
    const [loadingCurrencyList, setLoadingCurrencyList] = useState(false)
    const [currencyList, setCurrencyList] = useState([])
    const [selectedItems, setSelectedItems] = useState([])
    const [openCheckModal, setOpenCheckModal] = useState(false)
    const [createLoading, setCreateLoading] = useState(false)
    const [dataToSave, setDataToSave] = useState(null)
    const [itemsToCheck, setItemsToCheck] = useState([])
    const [fileToUpload, setFileToUpload] = useState()
    const [loadingPreview, setLoadingPreview] = useState(false)
    const [previewData, setPreviewData] = useState()
    
    const documenTypeOptions = ['invoice', 'debit_note', 'credit_note']

    useEffect(() => {
        getBases()
        getCurrencies()
    }, [])
   
    let searchTimeoutSupplier
    const getSupplier = async (name) => {
        clearTimeout(searchTimeoutSupplier)
        let params = {}
        if(Number.isNaN(Number(name))){
            params.name = name
        } else {
            params.id = Number(name)
        }
        searchTimeoutSupplier = setTimeout(async () => {
            try {
                setSupplierLoading(true)
                const suppliers = await supplierServices.getByParam(params)
                setSupplierOptions(suppliers)
                setSupplierLoading(false)
            } catch (error) {
                setSupplierOptions([])
                setSupplierLoading(false)
            }
        }, 700)
    }
    
    const getBases = async () =>{
        setLoadingBasesList(true)
        await billingServices.getBillingBases().then(res=>{
            const baseArray = Object.entries(res?.options ?? [])
            setBasesList(
                baseArray
                    .map(([name, id]) => ({ name, id }))
                    .filter((base, index, self) => self.findIndex(elem => elem.name === base.name) === index)
            )
        }).finally(()=>{
            setLoadingBasesList(false)
        })
    }

    const getCurrencies = async () => {
        try {
            setLoadingCurrencyList(true)
            const allCurrencies = await currencyServices.getByAll()
            setCurrencyList(allCurrencies)
            setLoadingCurrencyList(false)
        } catch (error) {
            setCurrencyList([])
            setLoadingCurrencyList(false)
        }
    }

    const handleDownloadFile = () => {
        if (!fileToUpload) return

        const url = URL.createObjectURL(fileToUpload)
        const link = document.createElement('a')
        link.href = url
        link.download = fileToUpload.name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => URL.revokeObjectURL(url), 1000)
    }

    const handleClickDeleteFile = (event) => {
        event.stopPropagation()
        setFileToUpload(null)
    }

    const onSuccess = () => {
        notify('ra.notification.created_success_femenine', {
            type: 'success',
            messageArgs: { element: translate('ra.single_entity.supplier-billing') }
        })
        redirect('/supplier-billing')
    }

    const onError = () => {
        notify('ra.notification.created_error_femenine', {
            type: 'error',
            messageArgs: { element: translate('ra.single_entity.supplier-billing') }
        })
        setOpenCheckModal(false)
    }

    const handlePreviewError = (error, callback) => {
        const body = error?.response?.data
        if (body?.status_code === 418 && error?.response) {
            const detail = body?.data?.errors || body?.data?.data || body?.data
            error.response.status = 418
            error.response.data = {
                ...body,
                data: { errors: Array.isArray(detail) ? detail : [detail] },
            }
        }
        showError(error, callback)
    }

    const handleCreateError = (error, callback) => {
        const body = error?.body || error
        if (body?.status_code === 418) {
            const detail = body?.data?.errors || body?.data?.data || body?.data
            error.status_code = 418
            error.response = {
                status: 418,
                data: {
                    ...body,
                    data: { errors: Array.isArray(detail) ? detail : [detail] },
                },
            }
        }
        showError(error, callback)
    }

    const onOpenCheckModal = async (data) => {
        let itemsToCheckAux = []
        for (let item of selectedItems) {
          const bills = await supplierBillingServices.checkBilling(item.item_id)
          if(bills.length){
            itemsToCheckAux.push(
                {
                    code: item.code ?? item.detail?.code,
                    name: item.detail?.name,
                    number: item.number,
                    item_id: item.item_id,
                    bills
                }
            )
          }
        }
        setItemsToCheck(itemsToCheckAux)
        if (itemsToCheckAux.length) {
            setOpenCheckModal(true)
        } else {
            customSave(data)
        }
    }

    const handleUploadFile = async () => {
        if (!fileToUpload) return null

        const formData = new FormData()
        formData.append('attachment_file', fileToUpload)

        try {
            const result = await itemSupplierServices.uploadFileInvoice(formData)
            return result
        } catch (error) {
            throw error
        }
    }

    const customSave = async (data) => {
        try {
            let attatchmentUrl
            try {
                attatchmentUrl = await handleUploadFile()
            } catch (error) {
                notify('ra.notification.upload_file_error', { type: 'error' })
                return
            }

            const safeSelectedItems = Array.isArray(selectedItems) ? selectedItems : []
            const dataAux = data ?? dataToSave
            const items_information = safeSelectedItems.map(item => (
                {
                    item_id: item.item_id,
                    amount: item.amount_pending
                }
            ))
            
            const dataToSend = {
                ...dataAux,
                date: dataAux.date.format('YYYY-MM-DD'),
                due_date: dataAux.due_date.format('YYYY-MM-DD'),
                accounting_date: dataAux.accounting_date.format('YYYY-MM-DD'),
                currency_id: dataAux.currency_id,
                supplier_id: dataAux.supplier?.id,
                status: "PENDING",
                base: basesList?.find(elem => elem.name === dataAux.base),
                items_information,
                amount: items_information.reduce((acc, current) => acc + current.amount, 0),
                attachment_url: attatchmentUrl
            }

            delete dataToSend.supplier

            setCreateLoading(true)
            await create(
                'supplier-billing/items',
                { data: dataToSend },
                { mutationMode: 'pessimistic', onSuccess, onError }
            )
            setCreateLoading(false)
            onSuccess()
        } catch (error) {
            setCreateLoading(false)
            handleCreateError(error, () => onError())
        }
    }

    const handlePreview = async (data) => {
        setPreviewData(null)
        const safeSelectedItems = Array.isArray(selectedItems) ? selectedItems : []
        const currency = currencyList.find(elem => elem.id === data?.currency_id)
        const dataToSend = {
            document_number: data?.document_number,
            supplier_id: data?.supplier?.id,
            invoice_date: data?.date?.format('YYYY-MM-DD'),
            invoice_date_due: data?.due_date?.format('YYYY-MM-DD'),
            item_info: safeSelectedItems.map(elem => ({ item_id: elem.item_id })),
            currency,
            exchanges: {},
            accounting_date: data?.accounting_date?.format('YYYY-MM-DD')
        }

        setLoadingPreview(true)
        await billingServices.visualizeInvoiceProvider(dataToSend).then((res) => (
            setPreviewData(res)
        )).catch((error)=>{
            handlePreviewError(error, () => {
                notify('ra.notification.visualize_invoice_error', {type:'error'})
            })
        }).finally(()=>{
            setLoadingPreview(false)
        })
    }

    return (
        <Create>
            <CardCommon title={translate('ra.title.create_billing')}>
                <SimpleForm
                    className='supplier-billing-form'
                    toolbar={<CardCrudBottomButtons
                        btnSave={true}
                        btnCancel={true}
                        btnPreview={true}
                        loading={createLoading}
                        loadingPreview={loadingPreview}
                        handlePreview={handlePreview}
                        previewIgnoreFields={['document_number','document_type', 'date', 'due_date', 'accounting_date']}
                    />}
                    onSubmit={(data) => {
                        setDataToSave(data)
                        onOpenCheckModal(data)
                    }}
                >
                    <Grid width='100%' display='flex' flexDirection='column' rowGap={6}>
                        <CardCommon title={translate('ra.title.suppliers')}>
                            <Grid container spacing={3}>
                                <EditInputsWrap className='small' label={translate('ra.field.supplier')} required md={6} lg={6}>
                                    <AutocompleteInput
                                        source='supplier'
                                        fullwidth
                                        options={supplierOptions}
                                        loading={supplierLoading}
                                        optionsText={['id','name']}
                                        onSearch={getSupplier}
                                        resetOnLoad={false}
                                        validate={[required()]}
                                    />
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.code')} md={3} lg={2}>
                                    <FormDataConsumer>
                                        {({ formData }) => {
                                            return (
                                                <TextField
                                                    fullWidth
                                                    size='small'
                                                    value={formData.supplier?.code}
                                                    disabled
                                                    placeholder={translate('ra.message.autocomplete_field')}
                                                />
                                            )
                                        }}
                                    </FormDataConsumer>
                                </EditInputsWrap>
                            </Grid>
                        </CardCommon>

                        <CardCommon title={translate('ra.title.voucher_details')}>
                            <Grid container spacing={3}>
                                <EditInputsWrap className='small' label={translate('ra.field.document_type')} required lg={3}>
                                    <SelectInput
                                        source='document_type'
                                        fullWidth
                                        options={documenTypeOptions.map(option => ({
                                            id: option,
                                            name: translate(`ra.field.${option}`)
                                        }))}
                                        optionsText={['name']}
                                        label=''
                                        validate={[required()]}
                                    />
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.document_number')} required lg={3}>
                                    <TextInput
                                        source='document_number'
                                        fullWidth
                                        label=''
                                        validate={[required()]}
                                    />
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.currency')} required lg={3}>
                                    {loadingCurrencyList ? (
                                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                                        ) : (
                                            <FormDataConsumer>
                                                {({ formData }) => (
                                                    <SelectInput
                                                        size='small'
                                                        fullWidth
                                                        label={false}
                                                        source='currency_id'
                                                        options={currencyList}
                                                        optionsText={['long_name']}
                                                        getOptionLabel={item => (
                                                            `${item.symbol} ${item.long_name} (${item.short_name})`
                                                        )}
                                                        validate={[required()]}
                                                        defaultValue={formData.supplier?.currency_id}
                                                    />
                                                )}
                                            </FormDataConsumer>
                                    )}
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.billing_base')} lg={3}>
                                    {loadingBasesList ? 
                                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                                    :
                                        <SelectInput
                                            source='base'
                                            fullWidth
                                            optionValue='name'
                                            options={basesList}
                                            optionsText={['name']}
                                            label={false}
                                        />
                                    }
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.voucher_date')} required lg={4}>
                                    <DatePickers
                                        source='date'
                                        viewsShow={false}
                                        defaultHour={0}
                                        defaultMinute={0}
                                        style={{ width: '100%' }}
                                        required
                                    />
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.due_date')} required lg={4}>
                                    <DatePickers
                                        source='due_date'
                                        viewsShow={false}
                                        defaultHour={0}
                                        defaultMinute={0}
                                        style={{ width: '100%' }}
                                        required
                                        defaultValue={dayjs()}
                                    />
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.accounting_date')} required lg={4}>
                                    <DatePickers
                                        source='accounting_date'
                                        viewsShow={false}
                                        defaultHour={0}
                                        defaultMinute={0}
                                        style={{ width: '100%' }}
                                        required
                                        defaultValue={dayjs()}
                                    />
                                </EditInputsWrap>

                                <EditInputsWrap className='small' label={translate('ra.field.file')} lg={4}>
                                    {fileToUpload ? (
                                        <div className='file' onClick={() => handleDownloadFile()}>
                                            <InsertDriveFile color='primary' className='file-icon' />
                                            <Tooltip title={fileToUpload.name}>
                                                <Typography className='name'>{fileToUpload.name}</Typography>
                                            </Tooltip>
                                            <IconButton
                                                className='delete-icon'
                                                size='small'
                                                onClick={(e) => handleClickDeleteFile(e)}
                                            >
                                                <Delete color='error' />
                                            </IconButton>
                                        </div>
                                    ) : (
                                        <Button
                                            variant='standard'
                                            startIcon={<Add />}
                                            style={{ color: blue }}
                                            component="label"
                                        >
                                                    {translate('ra.action.add_file')}
                                                    <input
                                                    type="file"
                                                    hidden
                                                    inputProps={{ multiple: false }}
                                                    onClick={(e) => e.target.value = null}
                                                    onChange={(e) => setFileToUpload(e.target.files?.[0])}
                                                    />
                                                </Button>
                                    )}
                                </EditInputsWrap>
                            </Grid>
                        </CardCommon>

                        <CardCommon title='Items'>
                            <FormDataConsumer>
                                {({ formData }) => (
                                    <ItemsTable
                                        hideTitle={true}
                                        supplierId={formData.supplier?.id}
                                        currencyId={formData.currency_id}
                                        selectedItems={selectedItems}
                                        setSelectedItems={setSelectedItems}
                                        isCreditNote={formData.document_type === 'credit_note'}
                                        hideIfNotSupplier={true}
                                        messageIfNoSupplier={translate('ra.message.select_supplier_to_search')}
                                        resetOnChangeSupplier={true}
                                        hiddenColumns={['amount_paid', 'amount_pending']}
                                    />
                                )}
                            </FormDataConsumer>
                        </CardCommon>

                        {previewData && (
                            <CardCommon title={translate('ra.title.preview')}>
                                <Grid container spacing={3}>
                                    {Object.entries(previewData).map(([field,value]) => (
                                        <Grid item xs={12} sm={4}>
                                            <Typography style={{fontWeight:'bold'}}>
                                                {`${translate(`ra.field.${field}`)}: `}
                                            </Typography>
                                            <Typography>
                                                {value}
                                            </Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            </CardCommon>
                        )}
                    </Grid>
                </SimpleForm>
            </CardCommon>

            <Dialog
                open={openCheckModal}
                onClose={() => {
                    setOpenCheckModal(false)
                    setItemsToCheck([])
                }}
                fullWidth
            >
                <DialogTitle>{translate('ra.title.invoice_already_exists')}</DialogTitle>
                <DialogContent>
                    <CheckItemsModal items={itemsToCheck}/>
                </DialogContent>
                <DialogActions style={{ display:'flex', flexDirection:'row', justifyContent:'space-between' }}>
                    <Button color='error' onClick={() => setOpenCheckModal(false)} variant='outlined'>
                        {translate('ra.action.cancel')}
                    </Button>
                    <LoadingButton
                        loading={createLoading}
                        loadingPosition='start'
                        variant='contained'
                        onClick={() => customSave()}
                        type='submit'
                        disabled={createLoading}
                    >
                        {translate('ra.action.save')}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Create>
    )
}
